import React, { Fragment, useEffect, useState } from 'react'
import SelectDropdown from '../../UI/SelectDropdown';
import closeIcon from '../../images/icons/close_icon.svg';
import { connect } from 'react-redux';
import { closeOrderPopUp } from '../../action/hCommerce2';
import Camera from './Camera';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';
import { withTranslation } from 'react-i18next';
import { CMSPath } from '../../../config/constant';

const AccompanyingGuestInput = (props) => {

    const { t } = props;
    const [selectedIdType, setSelectedIdType] = useState({});
    const [showIdList, setShowIdList] = useState({});
    const [cameraPrev, setCameraPrev] = useState(false)
    const [imageUrls, setimageUrls] = useState({})
    const [selectedGuest, setSelectedGuest] = useState(null);
    const [guestsNameDetails,setGuestsNameDetails]=useState({});
    const [showSalutationList, setShowSalutationList]=useState(0);
    const listData = ["Mr.", "Mrs.", "Ms.", "Dr.", "Miss"]

    useEffect(() => {

        if(props.guestList){
            
            let existingGuestNameDetails={};
            props.guestList.forEach((guest)=>{
                existingGuestNameDetails = {
                    ...existingGuestNameDetails, [guest.profileId]: {
                        profileId: guest.profileId,
                        firstName: guest.firstName || guest.name3,
                        lastName: guest.lastName || guest.name1,
                        nameTitle: guest.nameTitle || "",
                    }
                }
            })
            setGuestsNameDetails(existingGuestNameDetails);
        }

        if(props.idImageArray.length > 0){
            props.idImageArray.map(guest => {

                let idObj = selectedIdType
                let imageObj = imageUrls

                idObj[guest.profileId] = guest.docType
                imageObj[guest.profileId] = guest.imageURI

                setSelectedIdType({...idObj})
                setimageUrls({...imageObj})
            })
        }

        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        const checkin_companion_guest_event_sent = localStorage.getItem("checkin_companion_guest_event_sent")
        if(!checkin_companion_guest_event_sent)
        props.sendAnalytics(
            null, // as no guesdetails in logout state 
            props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "COMPANION DETAILS", 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "COMPANION DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")},
            0, 
            false, // guest is not logged in
            () => localStorage.setItem("checkin_companion_guest_event_sent", true)
        );
    }, [])

    const saveImage = (guestId, url) => {
        let obj = imageUrls;
        obj[guestId] = url;
        console.log("image url", guestId, url)
        setimageUrls({...obj});
    }

    const getOCRTexts = async(imageContent, callback) => {
        await fetch("https://vision.googleapis.com/v1/images:annotate/?key=AIzaSyAFwpDICdlbldOY4tQQRJQkAetrbYMz2NA", {
        method: 'POST',
        body: JSON.stringify({"requests": [{
                    "image": {
                        "content": imageContent
                    },
                    "features": [
                        {"type": "TEXT_DETECTION"}
                    ],
                    "imageContext": {
                        "languageHints": ["en"]
                            }
                }]}),
        headers: {
          "Content-Type": "application/json"
        },
      }).then((response) => {
          response.json().then(data => callback(data.responses[0].fullTextAnnotation.text))
      }).catch(error => {
        console.log("error", error)
      })
    }

    const readFile = (uri, callback) => {

        const self = this;
        function readBinaryFile(fileEntry) {
          fileEntry.file(function (file) {
              var reader = new FileReader();
    
              reader.onloadend = function() {
                  console.log("this.result.split(",")[1];",this.result.split(",")[1])
                  callback(this.result.split(",")[1]);
              };
    
              reader.readAsDataURL(file);
    
          }, resOnError);
        }
        if(window.cordova) window.resolveLocalFileSystemURL(uri, readBinaryFile, resOnError)
    }

    const resOnError = (error) => {
        console.log('idcard error: ', error);
        props.showLoader(false)
        props.setError(error.message)
    }

    const getName = (type, guestId) => {
        let name =  props.guestList.map(guest => {
            if(JSON.stringify(guest).includes(guestId)){
                console.log("found guest", guest, type, guest[type])
                return guest[type]
            }
        })
        return name[0]
    }

    const changeNameField=(profileId,fieldName,updatedValue)=>{
        // console.log("current guestNameDEtails", guestsNameDetails);
        let copyGuestsNameDetails= JSON.parse(JSON.stringify(guestsNameDetails));
        let selectedGuest= copyGuestsNameDetails[profileId];
        selectedGuest={...selectedGuest, [fieldName]:updatedValue};
        copyGuestsNameDetails={...copyGuestsNameDetails,[profileId]:selectedGuest};
        setGuestsNameDetails(copyGuestsNameDetails);
        // console.log("after guestNameDEtails", copyGuestsNameDetails);
    }

    const handleNext = async() => {

        try{

            console.log("Object.keys(imageUrls).length != props.guestList",Object.keys(imageUrls).length, props.guestList.length);
            if(Object.keys(imageUrls).length != props.guestList.length){
                props.closeOrderPopUp(true, "Please take a picture of your companions ID's to proceed", "", true)
                return;
            }
            
            if (props.cardChecksData.accompanyGuestApproach == "guestNameWithId"){
                console.log("guestsNameDetails",guestsNameDetails)

                const warningMessages = {
                    nameTitle: t("check_in.empty_salutations_warning"),
                    firstName: t("check_in.empty_firstname_warning"),
                    lastName: t("check_in.empty_lastname_warning")
                };

                for (const key in warningMessages) {
                    if (Object.values(guestsNameDetails).some(guest => !guest[key] || guest[key] === '')) {
                        props.closeOrderPopUp(true, warningMessages[key], "", true);
                        return;
                    }
                }
            }

            let idImageArray = []
            let updatedGuestsNameArray=[];
            for(let key in imageUrls) idImageArray.push({profileId: key, imageURI: imageUrls[key], docType: selectedIdType[key]})
            for(let key in guestsNameDetails ){
                updatedGuestsNameArray.push(guestsNameDetails[key]);
            }
            console.log(updatedGuestsNameArray,"updatedGuestsNameArray")
            props.next(idImageArray,updatedGuestsNameArray)

            // let ocrTexts = {}
            // props.showLoader(true)
            // let idImageArray = []
            // let isError = false
            
            // for(let key in imageUrls){
            //     let val = 1
            //     idImageArray.push({profileId: key, imageURI: imageUrls[key], docType: selectedIdType[key]})
            //     readFile(imageUrls[key], (img) => getOCRTexts(img, (texts) => {
            //         ocrTexts[key] = texts
            //         console.log("ocrTexts AG",ocrTexts)

            //         let firstName = getName("firstName", key)
            //         let lastName = getName("lastName", key)

            //         console.log("firstName, lastName",firstName, lastName, getName("firstName", key))

            //         if((texts.split(" ").join("").toLowerCase().includes(firstName.split(" ").join("").toLowerCase) || texts.split(" ").join("").toLowerCase().includes(lastName.split(" ").join("").toLowerCase))){
            //             console.log("matches fist or last  name");
            //             props.showLoader(false)
            //         } else {
            //             props.showLoader(false)
            //             props.setError(`Name and ID does not match for ${firstName}`)
            //             val = 0
            //             isError = true
            //         }
            //     }));
            //     if(val == 0){
            //         console.log("breaking the loop")
            //         break;
            //     }
            // }

            // console.log("isError", isError)

        } catch (error) {
            console.log("error", error);
            props.showLoader(false)
            props.setError(error.message)
        }
    }

    return (
        cameraPrev ? <Camera idCapture={true} heading="Guest Check In" nextPath={null} 
                saveImage = {(url) => saveImage(selectedGuest, url)} image = {imageUrls[selectedGuest]} backBtn = {() => setCameraPrev(false)}
                click_single_picture={true} hidePicturePreview = {() => setCameraPrev(false)} />

        : <Fragment>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={props.back}></a>
                <div className="heading align-center">{console.log("image url",imageUrls)}
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                    {/* <p className="bold" style={{ color: "inherit" }}>{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                </div>
            </header>
            <section className="widgets padding-0 margin-0 container-bg">

                <div class="widget-header widget-header-checkin-inner">
                    { props.currentWidgetObj.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                </div>

                <div className="widgets">
                    <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                        <h2 className="all-caps">{t("check_in.companion_details")}</h2>
                    </div>
                    <div className="form-window">
                        <div className="form-window-heading">
                            Provide Companion Details
                        </div>


                        <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1 seperator" style={{ borderColor: "ccc" }}>
                            {props.guestList.map((guest,index) =>  
                            
                            <>
                                <div class="form-row">

                                    {
                                        (props.cardChecksData.accompanyGuestApproach == "guestNameWithId") ?

                                        <>
                                            <label>{`Guest ${index + 1}`}<text style={{ color: 'red' }} >*</text></label>

                                            <div className="form-row margin-bottom-1">
                                                <label>{t("check_in.salutation_guest")}</label>
                                                <div className="custom-select align-left" >
                                                    <div className="select-selected" onClick={() => { showSalutationList == index + 1 ? setShowSalutationList(0) : setShowSalutationList(index + 1); }}>
                                                        {guestsNameDetails[guest.profileId] && guestsNameDetails[guest.profileId].nameTitle != '' ? guestsNameDetails[guest.profileId].nameTitle : "Please Select"}
                                                    </div>
                                                    {(showSalutationList == index + 1) && <div className="select-items">
                                                        {listData.map((item) => {
                                                            return (
                                                                <div onClick={() => { changeNameField(guest.profileId, "nameTitle", item); setShowSalutationList(0) }}>{item}</div>
                                                            )
                                                        })}
                                                    </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="form-row margin-bottom-1">
                                                <label for="guestName">{t("check_in.first_name_guest")}</label>
                                                <input name="guestName" id="companionFName" type="text" value={guestsNameDetails[guest.profileId] ? guestsNameDetails[guest.profileId].firstName : ""} onChange={(e) => { changeNameField(guest.profileId, "firstName", e.target.value) }} />

                                            </div>
                                            <div className="form-row margin-bottom-1">
                                                <label for="guestName">{t("check_in.last_name_guest")}</label>
                                                <input name="guestName" id="companionLName" type="text" value={guestsNameDetails[guest.profileId] ? guestsNameDetails[guest.profileId].lastName : ""} onChange={(e) => { changeNameField(guest.profileId, "lastName", e.target.value) }} />

                                            </div>
                                        </>
                                        :
                                        <label>Scan ID for {guest.firstName}<text style={{ color: 'red' }} >*</text></label>
                                    }

                                <div className="form-row">
                                    <label> {t("check_in.id_type")}</label>
                                    <SelectDropdown
                                        selectKey="obj.value"
                                        selectedItem={selectedIdType[guest.profileId]}
                                        listData={props.guestDocOptions}
                                        showList={showIdList[guest.profileId]}
                                        setShowList={() => {
                                            console.log("idImages, selectedIdType, showIdList", showIdList[guest.profileId])
                                            let obj = showIdList
                                            obj[guest.profileId] = !obj[guest.profileId]
                                            setShowIdList({...obj})
                                        }}
                                        setSelectedItem={(obj) => {
                                            let profileId = guest.profileId
                                            let listObj = showIdList
                                            let idObj = selectedIdType
                                            let imgObj = imageUrls

                                            idObj[profileId] = obj.value
                                            listObj[profileId] = false
                                            // imgObj[profileId] = null
                                            delete obj[guest.profileId]

                                            setSelectedIdType({...idObj});
                                            setShowIdList({...listObj})
                                            setimageUrls({...imgObj})
                                            // setIdImages(imgObj)
                                        }}
                                    />
                                </div>
                               
                                {!imageUrls[guest.profileId] && <div className="form-row margin-bottom-2">
                                    <div onClick={() => {
                                        if(selectedIdType[guest.profileId]){
                                            setCameraPrev(true) 
                                            setSelectedGuest(guest.profileId)
                                        } else {
                                            props.closeOrderPopUp(true, "Please select the id type", "", true)
                                        }
                                    }}>
                                        <label for="scanId" className="photo-uploader">Take a photo of your ID</label>
                                    </div>
                                </div>
                                }
                                {imageUrls[guest.profileId] && <div style={{ background: "#000", height: "300px", marginBottom: '20px', position: 'relative', overflow: "hidden" }}>
                                    <img src={closeIcon} className="id_image_delete_icon" onClick={() => {
                                                            let obj = imageUrls
                                                            // obj[guest.profileId] = null
                                                            delete obj[guest.profileId]
                                                            setimageUrls({...obj})
                                                        }} style={{ position: 'absolute', top: '10px', right: '10px', width: '20px', zIndex: '5' }} />
                                    <img src={`${imageUrls[guest.profileId]}`} height="100%" width="100%" style={{ marginBottom: '10px', objectFit: 'contain', transform: `rotate(${props.idRotateDeg}deg)` }} />
                                </div>
                                }
                                </div>
                            </>)}
                        </div>
                            <div className="form-controls">
                                <button 
                                    disabled={Object.keys(imageUrls).length != props.guestList.length} 
                                    className="primary w-100 all-caps" 
                                    onClick={handleNext}>Next</button>
                            </div>
                    </div>
                </div>
                
            </section>
        </Fragment>
    )
}

const mapStateToProps = state => {
    return {
      guestDocOptions: state.store.guestDocOptions,
      idRotateDeg: state.store2.id_rotate_deg,
      logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
      currentWidgetObj: state.store.sideNavBar.currentWidget,
      currentHomePage: state.store2.currentHomePage,
      guestDetail: state.store.home.guestDetails,
      guestIsLoggedIn: state.store2.guestIsLoggedIn,
      installedAppVersion: state.store.installedAppVersion,
      installedAppBuildNo: state.store.installedAppBuildNo,
      cardChecksData: state.store2.cardChecksData,
    }
  }
export default connect(
mapStateToProps,
{
    closeOrderPopUp,
    sendAnalytics
}
)(withTranslation('translations')(AccompanyingGuestInput));